const asc = (a, b) => a - b;
const desc = (a, b) => b - a;

export default ({ data, prop, sort }) => {
  const sortFn = sort === 'asc' ? asc : desc;
  return data.sort((a, b) => sortFn(a[prop], b[prop]));
};
